module.exports = "https://img.xiyuyouxi.com/saas/img/mark_bs.fa807322.png";